/**
 * BudgetStatusBadge
 * Color-coded budget status badge: green (within), amber (soft_alert), red (exhausted).
 */

export type BudgetStatus = 'within' | 'soft_alert' | 'exhausted';

interface BudgetStatusBadgeProps {
  status: BudgetStatus;
  className?: string;
}

const statusConfig: Record<
  BudgetStatus,
  { label: string; className: string }
> = {
  within: {
    label: 'Within Budget',
    className: 'bg-success/10 text-success border border-success/30',
  },
  soft_alert: {
    label: 'Soft Alert',
    className: 'bg-warning/10 text-warning border border-warning/30',
  },
  exhausted: {
    label: 'Exhausted',
    className: 'bg-destructive/10 text-destructive border border-destructive/30',
  },
};

export function BudgetStatusBadge({
  status,
  className = '',
}: BudgetStatusBadgeProps) {
  const config = statusConfig[status] ?? statusConfig.within;
  return (
    <span
      data-testid={`budget-status-badge-${status}`}
      className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${config.className} ${className}`}
      aria-label={`Budget status: ${config.label}`}
    >
      {config.label}
    </span>
  );
}
